import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.996 8.996V7.008c.001-.043 0-.054.004-.097.044-.449.423-.845.879-.9.094-.011.115-.007.145-.007.043.002.054.002.097.007.448.054.834.442.879.9.004.043.003.054.004.097v1.988h1.992l.048.001c.49.035.918.441.954.93.039.545-.424 1.063-1.002 1.077h-1.992V13a1.04 1.04 0 0 1-.648.939c-.584.221-1.327-.217-1.359-.891L8.996 13v-1.996H7.004c-.511-.012-.966-.435-1.002-.931-.038-.53.396-1.049.954-1.076l.048-.001h1.992z"
});

var SvgCirclePlusMajorMonotone = function SvgCirclePlusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgCirclePlusMajorMonotone as S };